// import { Operation } from 'slate';
import { createTPluginFactory, ElementPluginOptions } from '../../plate';
import { KEY_SECTION_TEMPLATE } from '../../pluginKeys';

export const createSectionTemplatePlugin = createTPluginFactory<ElementPluginOptions>({
  key: KEY_SECTION_TEMPLATE,
  isElement: true,
  options: {
    isDreamBlock: true,
    meta: {
      img: '/canvas/images/accordion.png',
      title: 'Section Template',
      subtitle:
        'Create your dream site contents in an instant',
      keywords: ['section', 'template'],
    },
    format: {
      formatType: 'command',
      // we just insert a paragraph, but open the dream modal
      onInsert: () => {
        throw Error('Did you forget to implement onInsert for the section template plugin?');
      },
      validProperties: [],
      focusableWhenEmpty: true,
    },
  },
});
